import Typography from "@material-ui/core/Typography";

const SubcontractorWithSubconIdentifierField = ({ record }: any) => {
  if (record !== null) {
    return (
      <Typography variant="body2">{`${record?.name} - ${
        record?.subcontractorIdentifier ?? "N/A"
      }`}</Typography>
    );
  }
  return <Typography variant="body2">loading...</Typography>;
};

export default SubcontractorWithSubconIdentifierField;
